import React     from 'react';
import { getColors } from '../../../../../constants/colors';
import { StyleSheet, View, Text } from 'react-native';
import { mbTextStyles } from '@mightybyte/rnw.utils.style-utils';
import { textStyles } from '../../../../../constants/textStyles';
import PeopleIcon from '../../../../../resources/svgComponents/PeopleIcon';
import { commaSeparatedNumber } from './utils/commaSeparatedNumber';
import Feather from 'react-native-vector-icons/Feather';

export enum ViewType {
    TOTAL_USERS = 'total_users',
    USER_BEHAVIOR = 'user_behavior',
}

interface Props {
    totalUsers?: number;
    viewType: ViewType;
    rightComponent?: React.ReactNode;
}
const COLORS = getColors();

export function TotalCard({ totalUsers, viewType, rightComponent }: Props) {
    return (
        <View style={styles.wrapper}>
            <View style={styles.container}>
                <View style={styles.iconContainer}>
                    {viewType === ViewType.TOTAL_USERS ?
                        <PeopleIcon size={40} color={COLORS['orange']} /> :
                        <Feather name={'activity'} size={40} color={COLORS['orange']} />}
                </View>

                <View style={styles.countContainer}>
                    <Text style={styles.totalUsersText}>{viewType === ViewType.TOTAL_USERS ? 'Total Users' : 'User\'s Behavior'}</Text>
                    {totalUsers ? <Text style={styles.totalUsersCount}>
                        {commaSeparatedNumber(totalUsers)}
                    </Text> : null}
                </View>
            </View>
            {rightComponent ? rightComponent : null}

        </View>
    );
}

const styles = StyleSheet.create({
    wrapper: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: COLORS['white'],
        padding: 20,
        marginBottom: 20,
        flex: 1,
        borderRadius: 15,
    },
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },

    countContainer: {
        marginLeft: 15,
    },

    iconContainer: {
        height: 60,
        width: 60,
        borderRadius: 999,
        backgroundColor: '#FEF2EE',
        alignItems: 'center',
        justifyContent: 'center',
    },

    totalUsersCount: mbTextStyles([
        textStyles.normalText,
        {
            color: '#A6A5A5',
            fontWeight: '600',
            fontSize: 20,
            textAlign: 'left',
        },
    ]),

    totalUsersText: mbTextStyles([
        textStyles.normalText,
        {
            color: '#313131',
            fontWeight: '600',
            fontSize: 24,
            textAlign: 'left',
        },
    ]),
});
